require('./interestsExample.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @core
const { FormattedText }= require('core/i18n').i18n;

class InterestsExample extends React.Component {
    render() {
        const { keyText, originCountry, benefitSection, reducedTopSpacing, alreadyProcessedText } = this.props;
        const containerClassName = reducedTopSpacing ? 'interests-example__container interests-example__container--reduced-top-spacing' : 'interests-example__container';
        let content = null;

        let text;
        if (originCountry === 'ES' || !!benefitSection){
            if (!alreadyProcessedText) {
                text = <FormattedText value={keyText} />;
            } else {
                text = keyText;
            };
            content = (
                <div className={containerClassName}>
                    {text}
                </div>
            );
        };

        return content;
    }
}

InterestsExample.propTypes = {
    alreadyProcessedText: PropTypes.bool,
    keyText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.element
    ]).isRequired,
    originCountry: PropTypes.string.isRequired,
    benefitSection: PropTypes.bool.isRequired,
    reducedTopSpacing: PropTypes.bool,
};
InterestsExample.defaultProps = {
    alreadyProcessedText: false,
    benefitSection: false,
    reducedTopSpacing: false,
};

module.exports = connect(
    state => ({
        originCountry: state.profile.get('originCountry'),
    })
)(InterestsExample);
